import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { ZeroCostProductView } from './ZeroCostProductView'

export const ZeroCostProduct = () => {
    const [products, setProducts] = useState([])
    const [disableButtons, setDisableButtons] = useState(false)
    const [response, setResponse] = useState()

 

    //fetch merchoid sales with zero costs
    useEffect(() => {
        axios.post(process.env.REACT_APP_HOST + 'api/merchoidSales/fetchZeroCostProducts', {
        }).then((res) => {
            console.log(res.data)
            const filteredData = res.data.filter((value, index, self) =>
                self.findIndex(v => v.sku === value.sku) === index
            );
            setProducts(filteredData)
        })
    }, [])

    const onClickSaveButton = (arr) => {
        setDisableButtons(true)
        const sku = arr[0]
        const productCost = arr[1]
        axios.post(process.env.REACT_APP_HOST + 'api/merchoidSales/updateZeroCostProduct', {
            params: {
                sku: sku,
                productCost: productCost
            }
        }).then((res) => {
            setDisableButtons(false)
            setResponse(res.data[0].sku)

        })
    }


    return <ZeroCostProductView
        products={products}
        onClickSaveButton={onClickSaveButton}
        disableButtons={disableButtons}
        response={response}
    />
}
